export const semantic = {
  red: '#db2828',
  orange: '#f2711c',
  yellow: '#F49625',
  olive: '#b5cc18',
  green: '#21ba45',
  teal: '#00b5ad',
  blue: '#2185d0',
  violet: '#6435c9',
  purple: '#a333c8',
  pink: '#e03997',
  brown: '#5A3A1B',
  grey: '#4F4F4F',
  black: '#1b1c1d',

  info: {
    background: '#f8ffff',
    foreground: '#276f86',
  },
  warn: {
    background: '#fffaf3',
    foreground: '#573a08',
  },
  error: {
    background: '#fff6f6',
    foreground: '#9f3a38',
  },
  success: {
    background: '#fcfff5',
    foreground: '#2c662d',
  },

  astronautBlue: '#033F63',
  lightBlue: '#2187D6',
  hummingBird: '#CFF0E7',
  sharpRed: '#C95D63',
}
